module.exports = {
      id: "virtual-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.0a12b861.svg#virtual-usage",
      toString: function () {
        return this.url;
      }
    }